// extracted by mini-css-extract-plugin
export default {"users-list":"UserList_users-list__8MdYD"};